import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import {
  FormControl, InputGroup,
} from 'react-bootstrap';

const STARTS_WITH = 'starts with';
const ENDS_WITH = 'ends with';
const CONTAINS = 'contains';
const EQUAL_TO = 'equal to';
const LESS_THAN = 'less than';
const GREATER_THAN = 'greater than';
const AFTER = 'after';
const BEFORE = 'before';

class FilterInputField extends PureComponent {
  constructor(props) {
    super(props);

    if (props.type === 'text') {
      this.state = {
        operator: 'eq',
        startsWith: true,
        endsWith: false,
        filterValue: '',
      };
    } else {
      this.state = {
        operator: 'gt',
        startsWith: false,
        endsWith: false,
        filterValue: '',
      };
    }

    this.onChangeOperator = this.onChangeOperator.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
  }

  onChangeOperator(event) {
    switch (event.target.value) {
      case STARTS_WITH: this.setState({ operator: 'eq', startsWith: true, endsWith: false }); break;
      case ENDS_WITH: this.setState({ operator: 'eq', startsWith: false, endsWith: true }); break;
      case CONTAINS: this.setState({ operator: 'eq', startsWith: true, endsWith: true }); break;
      case EQUAL_TO: this.setState({ operator: 'eq', startsWith: false, endsWith: false }); break;
      case LESS_THAN:
      case BEFORE: this.setState({ operator: 'lt', startsWith: false, endsWith: false }); break;
      case GREATER_THAN:
      case AFTER: this.setState({ operator: 'gt', startsWith: false, endsWith: false }); break;
      default: this.setState({ operator: '', startsWith: false, endsWith: false });
    }

    const { filterValue } = this.state;
    const { onChange } = this.props;
    if (filterValue.length >= 3) {
      onChange(this.mountQuery(event.target.value));
    }
  }

  onChangeFilter(event) {
    const { onChange } = this.props;
    const { filterValue: oldValue } = this.state;
    this.setState({ filterValue: event.target.value });

    if (event.target.value.length >= 3 || oldValue.length >= 3) {
      onChange(this.mountQuery(event.target.value));
    }
  }

  mountQuery(filterValue) {
    if (!filterValue) {
      return undefined;
    }

    const { field } = this.props;
    const {
      operator, startsWith, endsWith,
    } = this.state;
    return `${field} ${operator} '${endsWith ? '*' : ''}${filterValue}${startsWith ? '*' : ''}'`;
  }

  render() {
    const { type, text } = this.props;
    const { filterValue } = this.state;
    const id = uuid.v4();

    let operators = [];
    if (type === 'text') {
      operators = [STARTS_WITH, ENDS_WITH, CONTAINS, EQUAL_TO];
    } else if (type === 'number') {
      operators = [GREATER_THAN, LESS_THAN, EQUAL_TO];
    } else if (type === 'date') {
      operators = [AFTER, BEFORE, EQUAL_TO];
    }

    return (
      <InputGroup size="sm">
        <InputGroup.Prepend>
          <InputGroup.Text id={id}>{text}</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl required as="select" onChange={this.onChangeOperator}>
          { operators.map((operator) => (
            <option key={operator}>{operator}</option>
          )) }
        </FormControl>
        <FormControl
          aria-label={text}
          aria-describedby={id}
          value={filterValue}
          onChange={this.onChangeFilter}
        />
      </InputGroup>
    );
  }
}

FilterInputField.propTypes = {
  field: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'date']).isRequired,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterInputField;
